import React from 'react';
import { BellIcon, ChevronDownIcon, Globe2Icon, MenuIcon, FlaskConicalIcon } from 'lucide-react';
import { org } from '../lib/org';
type TopBarProps = {
  onMenuToggle: () => void;
};
export function TopBar({
  onMenuToggle
}: TopBarProps) {
  return <header className="w-full border-b border-line bg-white" data-id="element-242" data-mp="1y42dmi1mh08f">
      {org.isDemo && <div className="flex items-center justify-center gap-2 border-b border-line bg-canvas px-5 py-1.5 text-[11px] text-muted" data-id="element-243" data-mp="1t6ag98i7klwu">
          <FlaskConicalIcon className="h-3.5 w-3.5" strokeWidth={1.75} data-id="element-244" data-mp="2lten7j0v3ab9" />
          <span data-id="element-245" data-mp="2lu6hmqiq31zy">
            Environnement de démonstration · talents, scores et résultats fictifs
          </span>
        </div>}
      <div className="flex h-[72px] items-center justify-between px-5 sm:px-8" data-id="element-246" data-mp="2c3v2e7tl96dr">
        <div className="flex items-center gap-3" data-id="element-247" data-mp="2c1r01ubc8ffl">
          <button type="button" aria-label="Ouvrir le menu" onClick={onMenuToggle} className="flex h-9 w-9 items-center justify-center rounded-full text-ink hover:bg-canvas focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand md:hidden" data-id="element-248" data-mp="39k0sx3ne8ii3">
            <MenuIcon className="h-5 w-5" strokeWidth={1.75} data-id="element-249" data-mp="66baeqc1gzgk" />
          </button>

          {org.agencyMode ?
        // Mode cabinet : sélecteur d'organisation. Masqué en cadrage entreprise.
        <button type="button" className="flex min-w-[178px] items-center justify-between gap-4 rounded-card border border-line bg-white px-3 py-2 text-left transition-colors hover:border-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-250" data-mp="3tic9y261l6bb">
              <span data-id="element-251" data-mp="35o14m6nk9a4r">
                <span className="block text-[9px] font-600 tracking-[0.12em] text-muted" data-id="element-252" data-mp="3al1c8m026kxz">ORGANISATION</span>
                <span className="mt-0.5 block text-[13px] font-500 text-ink" data-id="element-253" data-mp="13uuso172ig06">{org.name}</span>
              </span>
              <ChevronDownIcon className="h-4 w-4 text-muted" strokeWidth={1.75} data-id="element-254" data-mp="18u7nb846krdb" />
            </button> : <div className="flex items-center gap-2.5" data-id="element-255" data-mp="16g2mvkl9qzj1">
              <span className="flex h-8 w-8 flex-none items-center justify-center rounded-card bg-ink text-[11px] font-600 tracking-tight text-white" data-id="element-256" data-mp="12dfo0zq6kecc">
                {org.initials}
              </span>
              <span className="min-w-0" data-id="element-257" data-mp="sfi06dc8gjk9">
                <span className="block truncate text-[14px] font-500 leading-tight text-ink" data-id="element-258" data-mp="sgjnbg6iwwic">{org.name}</span>
                <span className="block text-[11px] leading-tight text-muted" data-id="element-259" data-mp="1q2h2b3lp2jpj">
                  {org.industry} · {org.headcount}
                </span>
              </span>
            </div>}
        </div>

        <div className="flex items-center gap-2" data-id="element-260" data-mp="1gbcjfssweepf">
          <span className="hidden items-center gap-1.5 rounded-full border border-line bg-canvas px-3 py-1 text-[11px] text-muted lg:flex" data-id="element-261" data-mp="1bevyf7gzwggk">
            En amont de {org.atsName}
          </span>
          <button type="button" aria-label="Langue : français" className="flex h-9 items-center gap-1.5 rounded-full px-2.5 text-[12px] font-600 text-muted hover:bg-canvas hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-262" data-mp="2429n6iaji5pl">
            <Globe2Icon className="h-4 w-4" strokeWidth={1.75} data-id="element-263" data-mp="2lbuamqwg1tz9" />
            FR
          </button>
          <button type="button" aria-label="Notifications" className="relative flex h-9 w-9 items-center justify-center rounded-full text-muted hover:bg-canvas hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-264" data-mp="2qbgp13o0dg9n">
            <BellIcon className="h-[18px] w-[18px]" strokeWidth={1.75} data-id="element-265" data-mp="342bs1zbtt35b" />
            <span className="absolute right-1.5 top-1.5 h-1.5 w-1.5 rounded-full bg-brand" aria-hidden="true" data-id="element-266" data-mp="391exvlzmrdec" />
          </button>
        </div>
      </div>
    </header>;
}